import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MultiSelectSearchFormFieldComponent } from '../../../../../shared/components/multi-select-search-form-field/multi-select-search-form-field.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TabTratamientoService } from '../../../../../shared/services/tab-tratamiento.service';
import { distinctUntilChanged, Subscription, zip } from 'rxjs';
import {
  IDataProcedimiento,
  IProcedGuardado,
  IProcedSelected,
} from '../../../../../shared/interfaces/procedimientos.interface';
import { MatDividerModule } from '@angular/material/divider';
import { A11yModule } from '@angular/cdk/a11y';

@Component({
  selector: 'soph-procedimientos',
  standalone: true,
  imports: [
    CommonModule,
    MultiSelectSearchFormFieldComponent,
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    A11yModule,
  ],
  templateUrl: './procedimientos.component.html',
  styleUrl: './procedimientos.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProcedimientosComponent {
  formProcedimientos: FormGroup;
  procedimientosOptions = signal<Array<IDataProcedimiento>>([]);
  procedOptions: IDataProcedimiento[] = [];
  procedimientosSelected: IProcedSelected[] = [];
  procedimientosGuardados: IProcedGuardado[] = [];
  subs: Subscription = new Subscription();

  get procedimientos() {
    return this.formProcedimientos.get('procedimientos')!;
  }

  constructor(private fb: FormBuilder, private tabTratamientoService: TabTratamientoService) {
    this.formProcedimientos = this.fb.group({
      procedimientos: [''],
    });

    this.procedimientos?.valueChanges.pipe(distinctUntilChanged()).subscribe((values: string[]) => {
      this.onProcedSelected(values);
      this.showProcedimientosGuardados();
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this.llamarServicios();
  }

  setOriginalValues(procedimientos: string[]) {
    this.procedimientos.setValue(procedimientos);
  }

  llamarServicios() {
    const subscribes = zip(this.tabTratamientoService.getProcedimientos()).subscribe({
      next: ([procedimientos]) => {
        this.procedimientosOptions.set(procedimientos);
        this.procedOptions = procedimientos;
      },
    });
    this.subs.add(subscribes);
  }

  showProcedimientosGuardados() {
    const data = this.procedimientos.value as string[];
    this.procedimientosGuardados = [];

    if (data && data.length > 0) {
      data.forEach((item) => {
        const procedimiento = this.procedimientosOptions().find((o) => o.idProcedimiento === item);

        if (
          procedimiento &&
          !this.procedimientosGuardados.some(
            (p) => p.idProcedimiento === procedimiento.idProcedimiento
          )
        ) {
          this.procedimientosGuardados.push(procedimiento);
        }
      });
    }
  }

  resetForm() {
    this.formProcedimientos.reset();
  }

  armarRequestProcedimientos(): string[] {
    if (this.procedimientos.value && this.procedimientos.value.length > 0) {
      return this.procedimientos.value;
    } else {
      return [];
    }
  }

  disableSelectorProcedimientos() {
    this.procedimientos.disable();
  }

  enableSelectorProcedimientos() {
    this.procedimientos.enable();
  }

  unselectProced(idTerapia: string) {
    const terapias = this.procedimientos.value;
    const newTerapias = terapias.filter((id: string) => idTerapia !== id);
    this.procedimientos.setValue(newTerapias);
  }

  onProcedSelected(idsProcedEmitidos: string[]) {
    this.procedimientosSelected = [];
    if (idsProcedEmitidos) {
      idsProcedEmitidos.forEach((id) => {
        const proced = this.procedOptions.find((proced) => proced.idProcedimiento === id);
        if (proced) {
          this.procedimientosSelected.push(proced);
        }
      });
    }
  }
}
